import { getSearchParam, setSearchParam } from '../../../utils/navigationUtils'
import { GENERATOR_SEARCH_PARAM } from '../generatorTypes'

export const getGeneratorSearchParam = (param: GENERATOR_SEARCH_PARAM) =>
	getSearchParam(param)

export const setGeneratorSearchParam = (
	param: GENERATOR_SEARCH_PARAM,
	value: string,
) => setSearchParam(param, value)
